/* GridComponent.js */

"use strict";

const EventEmitter = require('events').EventEmitter;
const Renderer = require("./GridRenderer");
const _ = require('lodash');

class GridComponent extends EventEmitter {
    constructor(configOptions) {
        super();

        this._id = _.get(configOptions, 'id', "grid_gl_" + Date.now());
        this._rows = _.get(configOptions, 'rows', {});
        this._columns = _.get(configOptions, 'columns', {});
        this._showHeader = _.get(configOptions, 'showHeader', true);
        this._columnOrder = _.get(configOptions, 'columnOrder', []);
        this._selectedRows = _.get(configOptions, 'selectedRows', []);
        this._singleSelect = _.get(configOptions, 'singleSelect', false);

        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners(){

    }
    _unregisterListeners(){

    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer(){
        return this.getRenderer();
    }
    getRenderer(){
        return this._renderer;
    }
    shutdown(){
        this._unregisterListeners();
        return this._renderer._shutdown()
            .then(()=>{
                this._renderer = undefined;

                this._id = undefined;
                this._rows = undefined;
                this._columns = undefined;
                this._showHeader = undefined;
                this._columnOrder = undefined;
                this._selectedRows = undefined;
                this._singleSelect = undefined;
            });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    _triggerUserSelectedRows(selectedRowKeys){
        this.emit('UserSelectedRows', selectedRowKeys);
    }

    _triggerUserRowDoubleClicked(selectedRowKey){
        this.emit('UserRowDoubleClicked', selectedRowKey);
    }

    _triggerUserSorted(columnKey, sorted){
        this.emit('UserSorted', columnKey, sorted);
    }

    _triggerGridAction(eventData){
        this.emit('GridAction', eventData);
    }

    _triggerGridResized(event){
        this.emit('GridResized', event);
    }

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    setId(newVal){
        this._id = newVal;
        this.emit('Id', this._id);
        return this;
    }
    getId(){
        return this._id;
    }

    setRows(newVal){
        let newSelectedRows = [],
            selectedRows = this.getSelectedRows();
        this._rows = newVal;
        this.emit('Rows', this._rows);
        selectedRows.forEach((row) => {
            if (!_.isUndefined(this._rows[row])) {
                newSelectedRows.push(row);
            }
        });
        this.setSelectedRows(newSelectedRows);
        return this;
    }
    getRows(){
        return this._rows;
    }

    addRow(row){
        _.assignIn(this._rows, row);
        this.emit('AddRow', row);
        return this;
    }
    getRow(rowKey){
        return this._rows[rowKey];
    }
    updateRow(row){
        let rowKey = Object.keys(row)[0];
        _.merge(this._rows, row);
        let updatedRow = {};
            updatedRow[rowKey] = this._rows[rowKey];
        this.emit('UpdateRow', updatedRow);
        return this;
    }
    deleteRow(row){
        let rowKey = Object.keys(row)[0],
            selectedRows = this.getSelectedRows(),
            newSelectedRows = [],
            selectedRowFound = false;
        this._rows = _.omit(this._rows, rowKey);
        selectedRows.forEach((row) => {
            if (row === rowKey) {
                selectedRowFound = true;
            } else {
                newSelectedRows.push(row);
            }
        });
        if (selectedRowFound === true) {
            this.setSelectedRows(newSelectedRows);
        }
        this.emit('DeleteRow', rowKey);
        return this;
    }

    sortRows(){
        this.emit('SortRows');
        return this;
    }

    setColumns(newVal){
        this._columns = newVal;
        this.emit('Columns', this._columns);
        return this;
    }
    getColumns(){
        return this._columns;
    }

    setColumnOrder(newVal){
        this._columnOrder = newVal;
        this.emit('ColumnOrder', this._columnOrder);
        return this;
    }
    getColumnOrder(){
        return this._columnOrder;
    }

    setShowHeader(newVal){
        this._showHeader = newVal;
        this.emit('ShowHeader', this._showHeader);
        return this;
    }    
    getShowHeader(){
        return this._showHeader;
    }

    setSelectedRows(rowIdArray){
        this._selectedRows = rowIdArray;
        this.emit('SelectedRows', this._selectedRows);
        return this;
    }
    getSelectedRows(){
        return this._selectedRows;
    }

    setSingleSelect(newVal){
        this._singleSelect = newVal;
        return this;
    }
    getSingleSelect(){
        return this._singleSelect;
    }
    
    
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = GridComponent;